import { Helpers } from '../../helpers';
import { IWellheadSection } from '../../interfaces/iwellhead-section';
import { WellheadCost } from '../wellhead-cost';

export class WellheadSectionBase {
  WellheadSectionId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  WellheadCosts_WellheadSection?: Array<WellheadCost> | null;

  constructor(item?: IWellheadSection) {
    if (item) {
      this.WellheadSectionId = item.WellheadSectionId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.WellheadCosts_WellheadSection = Helpers.createClassArray(WellheadCost, item.WellheadCosts_WellheadSection);
    }
  }
}